import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const InsertPageBreakOutlined = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 24 24"
  >
    <mask
      id="mask0_2217_25336"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2217_25336)">
      <path
        d="M6 22C5.45 22 4.97933 21.8043 4.588 21.413C4.196 21.021 4 20.55 4 20V17H6V20H18V17H20V20C20 20.55 19.8043 21.021 19.413 21.413C19.021 21.8043 18.55 22 18 22H6ZM4 11V4C4 3.45 4.196 2.979 4.588 2.587C4.97933 2.19567 5.45 2 6 2H14L20 8V11H18V9H13V4H6V11H4ZM9 15V13H15V15H9ZM17 15V13H23V15H17ZM1 15V13H7V15H1Z"
        fill="#6B6B6B"
      />
    </g>
  </SvgIcon>
));

InsertPageBreakOutlined.displayName = 'InsertPageBreakOutlined';

export default InsertPageBreakOutlined;
